export const PERMISSION_ACTIONS = {
  FEED_COMMUNITY_VIEW_FEED: "feed_community.view_feed",
  FEED_COMMUNITY_COMMENT: "feed_community.comment",
  FEED_COMMUNITY_VIEW_COMMENTS: "feed_community.view_comments",
  FEED_COMMUNITY_PUBLISH_PROFILE_POST: "feed_community.publish_profile_post",
  FEED_COMMUNITY_PUBLISH_COMMUNITY_POST:
    "feed_community.publish_community_post",
  FEED_COMMUNITY_LIKE: "feed_community.like",
  FEED_COMMUNITY_FOLLOW: "feed_community.follow",
  FEED_COMMUNITY_PLAY_VIDEOS: "feed_community.play_videos",
  // Storie. Both are configured per profile in the CRM: viewing is open to
  // Guests, publishing is not, so a Guest tapping "Condividi una storia" is the
  // case these gate.
  FEED_COMMUNITY_VIEW_STORIES: "feed_community.view_stories",
  FEED_COMMUNITY_PUBLISH_STORY: "feed_community.publish_story",
  CHAT_GROUPS_CAN_ACCESS_GROUPS: "chat_groups.can_access_groups",
  CHAT_GROUPS_CAN_ACCESS_SUPPORT: "chat_groups.can_access_support",
  CHAT_GROUPS_CAN_ACCESS_PERSONAL: "chat_groups.can_access_personal",
  // Premium Lite: refusal popup when the thematic group chat limit is reached.
  CHAT_GROUPS_UNLIMITED_THEMATIC: "chat_groups.unlimited_thematic_groups",
  CHALLENGES_ACTIVITIES_CAN_SUBSCRIBE:
    "challenges_activities.can_subscribe",
  NOTIFICATIONS_CHOOSE_TOPICS: "notifications.choose_topics",
  DIET_PLAN_FIND_RECIPES: "diet_plan.find_recipes",
  DIET_PLAN_RANK_RECIPES: "diet_plan.rank_recipes",
  DIET_PLAN_DAILY_MENU: "diet_plan.daily_menu",
  DIET_PLAN_SHOPPING_LIST: "diet_plan.shopping_list",
  DIET_PLAN_DISLIKED_FOODS: "diet_plan.disliked_foods",
  DIET_PLAN_CHANGE_PROTOCOL: "diet_plan.change_protocol",
  DIET_PLAN_SUBSTITUTION: "diet_plan.substitution",
  DIET_PLAN_CALENDAR: "diet_plan.calendar",
  DIET_PLAN_OPEN_MAGAZINE: "diet_plan.open_magazine",
  // Premium Lite (client, 14/10/2026): popup for Lite by default in the CRM.
  DIET_PLAN_SEARCH_RECIPES: "diet_plan.search_recipes",
  DIET_PLAN_ADVANCED_RECIPE_FILTERS: "diet_plan.advanced_recipe_filters",
  DIET_PLAN_ALL_JOURNEYS: "diet_plan.all_journeys",
  STREAMING_VIDEOS_MOVEMENT_LIBRARY: "streaming_videos.movement_library",
  DIET_PLAN_MASTER_CLUB_ROUTE_ADOC: "diet_plan.master_club_route_adoc",
  PERSONAL_PROFILE_MAKE_LOCATION_VISIBLE:
    "personal_profile.make_location_visible",
  PERSONAL_PROFILE_VIEW_USERS_ON_MAP:
    "personal_profile.view_users_on_map",
  PERSONAL_PROFILE_VIEW_COIN_BALANCE:
    "personal_profile.view_coin_balance",
  YOUR_PATH_INSERT_WEIGHT_MEASURES: "your_path.insert_weight_measures",
  YOUR_PATH_UPLOAD_PHOTOS: "your_path.upload_photos",
  YOUR_PATH_VIEW_BASIC_HISTORY: "your_path.view_basic_history",
  YOUR_PATH_GENERATE_BEFORE_AFTER: "your_path.generate_before_after",
  YOUR_PATH_PUBLISH_BEFORE_AFTER: "your_path.publish_before_after",
  YOUR_PATH_EARN_COINS_BEFORE_AFTER: "your_path.earn_coins_before_after",
  STREAMING_VIDEOS_WATCH_PREMIUM_VIDEOS:
    "streaming_videos.watch_premium_videos",
};

export const COMMUNITY_FEED_PATH = "/community";
